import { render, staticRenderFns } from "./StoreLocatorConfigPhotos.vue?vue&type=template&id=4bea746b&scoped=true&"
import script from "./StoreLocatorConfigPhotos.vue?vue&type=script&lang=js&"
export * from "./StoreLocatorConfigPhotos.vue?vue&type=script&lang=js&"
import style0 from "./StoreLocatorConfigPhotos.vue?vue&type=style&index=0&id=4bea746b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bea746b",
  null
  
)

export default component.exports